export default __webpack_public_path__ + "static/media/governance-hierarchy-mobile.f039b2b1.png";